import React from 'react';
import LoadingScreen from '../../LoadingScreen';
import LogsList from './LogsList';
import useOrgConfirmationLogs from '../hooks/useOrgConfirmationLogs';
import OrgConfirmationLog from './OrgConfirmationLog';

export default function OrgConfirmationLogs({
  token,
  orgId,
}: {
  token: string;
  orgId: string;
}): React.JSX.Element {
  const { logs, isLoading } = useOrgConfirmationLogs({ orgId });
  if (isLoading) {
    return <LoadingScreen />;
  }
  return (
    <LogsList logs={logs} token={token} LogComponent={OrgConfirmationLog} />
  );
}
